import posthog from "posthog-js";
import { usePostHog } from "posthog-js/react";
import { EventCaptureFunction } from "./event-type";
import { Experiments } from "./experiments";

/**
 * this should only be used if we do not need server-side rendering. Since this call happens on the frontend
 * and there is a delay before the flag is returned, the UI can flicker between control / test states.
 */
export function useExperiment<T extends keyof Experiments>(key: T): Experiments[T] | undefined {
  const posthog = usePostHog();

  return posthog.getFeatureFlag(key) as Experiments[T] | undefined;
}

export const captureClientEvent: EventCaptureFunction = async (event, properties) => {
  try {
    posthog.capture(event, properties);
  } catch (e) {}
};
